import DataAvailabilityDateRangePickerWrapper from 'ui/clinicianScreens/Patient/DataAvailabilityDateRangePicker/DataAvailabilityDateRangePickerWrapper'
import TabActionableHeader from 'ui/templates/TabActionableHeader'

const DailyViewsHeader = () => (
  <TabActionableHeader>
    <DataAvailabilityDateRangePickerWrapper />
  </TabActionableHeader>
)

DailyViewsHeader.propTypes = {}

DailyViewsHeader.defaultProps = {}

export default DailyViewsHeader
